export default __webpack_public_path__ + "static/media/communicator_app_login.75f36b73.png";